import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import posthog from 'posthog-js'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  })
} else if (import.meta.env.DEV) {
  console.warn('[Sentry] VITE_SENTRY_DSN manquante — tracking erreurs désactivé')
}

const phKey = import.meta.env.VITE_POSTHOG_KEY
if (phKey) {
  posthog.init(phKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    persistence: 'memory',
    opt_out_capturing_by_default: true,
  })
  if (import.meta.env.DEV) {
    ;(window as any).posthog = posthog
  }
} else if (import.meta.env.DEV) {
  console.warn('[PostHog] VITE_POSTHOG_KEY manquante — tracking désactivé')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch((err) => {
    console.error('Service Worker registration failed:', err)
  })
}
